/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_License_PcInputs */

const en_pc_cmp_r_license_pc = /** @type {(inputs: Pc_Cmp_R_License_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source, MIT or Apache-2.0`)
};

const zh_pc_cmp_r_license_pc = /** @type {(inputs: Pc_Cmp_R_License_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源，MIT 或 Apache-2.0`)
};

/**
* | output |
* | --- |
* | "Open source, MIT or Apache-2.0" |
*
* @param {Pc_Cmp_R_License_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_license_pc = /** @type {((inputs?: Pc_Cmp_R_License_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_License_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_license_pc(inputs)
	return zh_pc_cmp_r_license_pc(inputs)
});
export { pc_cmp_r_license_pc as "pc.cmp.r.license.pc" }